export default __webpack_public_path__ + "static/3-packages-0178b1f78823a35d771d17bf7736692e.png";